<template>
  <div class="container">
    <div class="content">
      <h1 class="title">…browser is unsupported</h1>
      <span>Here is a list of supported browsers:</span>
      <ul class="list">
        <li class="list-item" v-for="browser in browsers" :key="browser">
          {{ browser }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { READABLE_SUPPORTED_BROWSERS } from '../../../utils/is-browser-valid';

export default {
  name: 'SAIUnsupportedBrowser',
  data() {
    return {
      browsers: READABLE_SUPPORTED_BROWSERS
    };
  }
};
</script>

<style lang="sass" scoped>
.container
  top: 0
  bottom: 0
  left: 0
  right: 0
  position: fixed
  background: rgba(5,22,41,0.46)
  padding: 8px
  display: flex
  align-items: center
  justify-content: center

.content
  padding: 24px
  width: 100%
  max-width: 560px
  background: white
  border-radius: 8px
  display: flex
  flex-direction: column
  align-items: center

.title
  color: $primary
  font-size: 24px
  line-height: 36px
  margin-bottom: 16px
  font-weight: 700

.list
  margin: 4px 0 0
  padding: 0

.list-item
  margin: 4px 0
  text-transform: capitalize
</style>
